import api from '../api';
import Unidade from '../model/Unidade';

interface ApiError {
    response?: {
        data: {
            message: string;
        };
        status: number;
    };
}
export class UnidadeViewModel {
    static async criarUnidade(dados: Unidade): Promise<Unidade> {
        try {
            const response = await api.post('/unidades', {
                nome: dados.nome,
                clientId: dados.clientId,
            });

            return {
                id: response.data.id,
                nome: response.data.nome,
                clientId: response.data.clientId,
            };
        } catch (error: unknown) {
            if (error instanceof Error) {
                const apiError = error as ApiError;
                if (apiError.response && apiError.response.status >= 400) {
                    throw new Error(apiError.response.data.message || 'Erro ao criar unidade');
                }
                throw new Error(error.message);
            }
            throw new Error('Erro desconhecido ao criar unidade');
        }
    }

    static async buscarUnidadesPorNome(nome: string, page: number = 0, size: number = 10, sort: string = 'nome,ASC'): Promise<Unidade[]> {
        try {
            const response = await api.get(`/unidades`, {
                params: {
                    nome,
                    pagination: false,  
                    page,
                    size,
                    sort
                }
            });
            // A lista de unidades está dentro de "_embedded.unidadeResponseList"
            return response.data._embedded?.unidadeResponseList || [];
        } catch (error: unknown) {
            if (error instanceof Error) {
                const apiError = error as ApiError;
                if (apiError.response && apiError.response.status >= 400) {
                    throw new Error(apiError.response.data.message || 'Erro ao buscar unidades');
                }
                throw new Error(error.message);
            }
            throw new Error('Erro desconhecido ao buscar unidades');
        }
    }   
    
    static async atualizarUnidade(unidadeId: string, dados: Unidade): Promise<Unidade> {
        try {
            const response = await api.patch(`/unidades/${unidadeId}`, {
                nome: dados.nome,
                clientId: dados.clientId,
            });
    
            return {
                id: response.data.id,
                nome: response.data.nome,
                clientId: response.data.clientId,
            };
        } catch (error: unknown) {
            if (error instanceof Error) {
                const apiError = error as ApiError;
                if (apiError.response && apiError.response.status >= 400) {
                    throw new Error(apiError.response.data.message || 'Erro ao atualizar unidade');
                }
                throw new Error(error.message);
            }
            throw new Error('Erro desconhecido ao atualizar unidade');
        }
    }
    
}

export default UnidadeViewModel;
